module.exports = __webpack_public_path__ + "img/i-technologies.fbe2690e.svg";